import React, { FC } from "react";
import { Metric } from "../types";
import { makeMetricIcons } from "./MetricIcons";

const ORDER: Metric[] = [
  "list",
  "assists",
  "crosses",
  "fouls",
  "goals",
  "keyPasses",
  "passAccuracy",
  "passes",
  "red",
  "yellow",
  "shots",
  "tackles",
  "xg",
  "saves",
];

type Props = {
  metric: Metric;
  setMetric: (m: Metric) => void;
  availableMetrics: Metric[];
};

const CategoryBar: FC<Props> = ({ metric, setMetric, availableMetrics }) => {
  const iconSizeLg = 48;
  const iconSizeSm = 20;
  const iconsLg = makeMetricIcons({ size: iconSizeLg });
  const iconsSm = makeMetricIcons({ size: iconSizeSm });

  return (
    <div className="flex gap-[1vw] overflow-x-auto pb-2">
      <div className="flex flex-nowrap gap-[1vw]">
        {ORDER.filter((m) => availableMetrics.includes(m)).map((m) => {
          const isActive = metric === m;
          return (
            <button
              key={m}
              type="button"
              onClick={() => setMetric(m)}
              className={`flex h-10 w-10 items-center justify-center rounded-lg border font-bold transition-colors lg:h-14 lg:w-14 lg:p-3 ${
                isActive
                  ? "border-green bg-green/10"
                  : "border-border bg-transparent"
              } `}
            >
              <span className="hidden h-12 w-12 items-center justify-center lg:inline-flex">
                {iconsLg[m]}
              </span>
              <span className="inline-flex h-5 w-5 items-center justify-center lg:hidden">
                {iconsSm[m]}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryBar;
